import { ValidatorFn, AbstractControl } from '@angular/forms';
import AppConstants from '../../shared/common-components/AppConstants';

export function emailsValidator(): ValidatorFn {
    return (control: AbstractControl): {[key: string]: boolean} | null => {
    const EMAIL_REGEXP = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    if (AppConstants.isNotNullCondition(control.value)) {
        const emails = control.value;
        const emailArray = emails.split(',');
        for (let i = 0; i < emailArray.length; i++) {
            if (!EMAIL_REGEXP.test(emailArray[i].trim())) {
                return {emailPattern : true};
            }
        }
    }
      return null;
    };
}
